<template>
	<div class="pt-3">
		<div class="mt-2 mb-2 fs-16 fw-700 text-color-rhapsody-in-blue">
			{{ title }}
		</div>
		<b-row>
			<b-col cols="6">
				<b-row>
					<b-col cols="6">
						<custom-form-group
							:label="FormMSG(1, 'Type')"
							:value="FormMSG(2, 'Camera equipment')"
							:is-disable="true"
							:add-unit="false"
							:enable-expend="true"
							:is-for-number="false"
						/>
					</b-col>
					<b-col cols="6">
						<custom-form-group
							:label="isAmount ? FormMSG(10, 'Amount') : FormMSG(3, 'Days used')"
							:value="cameraValue"
							:is-disable="isDisable"
							:add-unit="isAmount ? true : false"
						>
							<template #append-icon>
								{{ currencySymbol }}
							</template>
						</custom-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="6">
						<custom-form-group
							:value="FormMSG(4, 'Lighting equipment')"
							:is-disable="true"
							:add-unit="false"
							:enable-expend="true"
							:is-for-number="false"
						/>
					</b-col>
					<b-col cols="6">
						<custom-form-group :value="lightingValue" :is-disable="isDisable" :add-unit="isAmount ? true : false">
							<template #append-icon>
								{{ currencySymbol }}
							</template>
						</custom-form-group>
					</b-col>
				</b-row>
			</b-col>
			<b-col cols="6">
				<b-row>
					<b-col cols="6">
						<custom-form-group
							:label="FormMSG(1, 'Type')"
							:value="FormMSG(5, 'Sound equipment')"
							:is-disable="true"
							:add-unit="false"
							:enable-expend="true"
							:is-for-number="false"
						/>
					</b-col>
					<b-col cols="6">
						<custom-form-group
							:label="isAmount ? FormMSG(10, 'Amount') : FormMSG(3, 'Days used')"
							:value="soundValue"
							:is-disable="isDisable"
							:add-unit="isAmount ? true : false"
						>
							<template #append-icon>
								{{ currencySymbol }}
							</template>
						</custom-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="6">
						<custom-form-group
							:value="FormMSG(6, 'Grip equipment')"
							:is-disable="true"
							:add-unit="false"
							:enable-expend="true"
							:is-for-number="false"
						/>
					</b-col>
					<b-col cols="6">
						<custom-form-group :value="gridValue" :is-disable="isDisable" :add-unit="isAmount ? true : false">
							<template #append-icon>
								{{ currencySymbol }}
							</template>
						</custom-form-group>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import CustomFormGroup from '@/components/Forms/CustomFormGroup';

export default {
	name: 'EquipmentDaysUsedForm',

	components: {
		CustomFormGroup
	},

	mixins: [languageMessages],

	props: {
		title: { type: String, required: true },
		gridValue: { type: Number, default: 0 },
		cameraValue: { type: Number, default: 0 },
		soundValue: { type: Number, default: 0 },
		lightingValue: { type: Number, default: 0 },
		isDisable: { type: Boolean, required: true },
		isAmount: { type: Boolean, default: false },
		currencySymbol: { type: String, default: '$' }
	},

	computed: {},

	methods: {}
};
</script>
